/** Static category labels for filters (e.g. category-results). Catalog categories are loaded from API for create/edit ad. */
export const CATEGORIES = [
  "Todos",
  "Eletrônicos",
  "Móveis",
  "Roupas",
  "Esportes",
  "Livros",
  "Veículos",
  "Outros",
];
